import { environment } from './environment';

export const ENV_CONFIG = {
  production: environment.production,
  countryCode: environment.countryCode,
  currency: environment.currency,
  /** Habilita botones de omisión en el flujo de activaciones (solo entorno de desarrollo) */
  activationsDevEnv: environment.activationsDevEnv,

  // Cada URL viene COMPLETA desde el environment (.env / panel de Amplify). No se
  // compone con sufijos: asi cada API puede apuntar al dominio personalizado o a la
  // URL cruda de AWS cambiando solo la variable de entorno.
  api: {
    base: environment.apiBaseUrl,
    auth: environment.apiAuthUrl,
    onboarding: environment.apiOnboardingUrl,
    passwordReset: environment.apiPasswordUrl,
    support: environment.apiSupportUrl,
    tokens: environment.apiTokensUrl,
    ventas: environment.apiVentasUrl,
    pin: environment.apiPinUrl,
    recargas: environment.apiRecargasUrl,
    compliance: environment.apiComplianceUrl,
    reportes: environment.apiReportesUrl,
    activaciones: environment.apiActivacionesUrl,
    activacionesIdentity: environment.apiActivacionesIdentityUrl,
    activation: environment.apiActivationUrl,
    provisioning: environment.apiProvisioningUrl,
    biometric: environment.apiBiometricUrl,
    sim: environment.apiSimUrl,
    portabilidad: environment.apiPortabilidadUrl,
    gestionComercial: environment.apiGestionComercialUrl,
  },

  endpoints: {
    auth: {
      login: '/login',
      logout: '/logout',
      invalidateSession: '/session/invalidate-previous',
      refreshToken: '/session/refresh',
    },
    support: {
      modules: '/modules/me',
      users: '/users',
      roles: '/admin/roles',
      permissions: '/admin/permissions',
      groups: '/admin/groups',
      groupMappings: '/admin/group-mappings',
      userStatus: (userCode: string) => `/user/${userCode}/status`,
      userUnlock: (userCode: string) => `/user/${userCode}/unlock`,
    },
    onboarding: {
      start: '/start',
      firstLogin: '/first-login',
      sendToken: '/send-token',
      sendVerification: '/send-verification',
      validateToken: '/validate-token',
      profile: '/profile',
      finalize: (userId: string) => `/${userId}/finalize`,
    },
    password: {
      resetRequest: '/reset/request',
      validateToken: (tokenId: string) => `/reset/validate/${tokenId}`,
      confirm: '/reset/confirm',
      change: '/change',
    },
    vendedor: {
      perfil: '/vendedor/perfil',
    },
    venta: {
      saldo: (numeroPOS: string) => `/saldo/${numeroPOS}`,
      paquetes: (numeroPOS: string) => `/paquetes/${numeroPOS}`,
      recomendados: (numeroPOS: string) => `/recomendados/${numeroPOS}`,
      seleccionarOferta: (ventaId: string) => `/${ventaId}/seleccionar-oferta`,
      ventaDirecta: '/venta-directa',
      resumen: '/resumen',
      detalle: '/detalle',
    },
    pin: {
      cambiar: '/cambiar',
    },
    recargas: {
      configuracion: '/configuracion',
      ejecutar: '/ejecutar',
    },
    compliance: {
      registryData: '/registry-data',
      registryPhoto: '/registry-photo',
      registryFinal: '/registry-final',
    },
    reportes: {
      resumen: '/resumen',
      detalle: '/detalle',
    },
    activaciones: {
      start: '',
      getStatus: (activationId: string) => `/${activationId}`,
      abandon: (activationId: string) => `/${activationId}`,
      config: (countryCode: string) => `/config/${countryCode}`,
      catalogLevels: (countryCode: string, catalogType: string) =>
        `/catalogs/levels?countryCode=${countryCode}&catalogType=${catalogType}`,
      catalogEntries: '/catalogs/entries',
      manualEntry: '/manual-entry',
      capture: '/capture',
      compareFaces: '/compare-faces',
      /** POST /activations-identity/government-validation — US-010 */
      governmentValidation: '/government-validation',
      /** POST /activations-identity/max-activations — valida máximo de activaciones por documento */
      maxActivations: '/max-activations',
      /** POST /activations-identity/ocr — extrae datos del documento via OCR */
      ocr: '/ocr',
      /** POST /activations/execute — ejecuta la activación de línea prepago (US-017) */
      execute: '/execute',
      /** POST /activations/{id}/workflow — arranca el workflow post-activación */
      workflow: (activationId: string) => `/${activationId}/workflow`,
    },
    biometric: {
      /** POST /biometric/iframe/begin-transaction — inicia transacción, retorna link del iframe */
      transaction: '/iframe/begin-transaction',
      /** POST /biometric/iframe/get-transaction — consulta resultado (usar con polling) */
      transactionResult: '/iframe/get-transaction',
    },
    sim: {
      /** POST /sim/capture — captura la serie SIM (manual, scan u OCR) (US-014) */
      capture: '/capture',
      /** POST /sim/validate — valida SIM contra inventario OwlNumber (US-015) */
      validate: '/validate',
      /** POST /sim/verify — verifica la SIM contra el sistema de activación (UssdActivationDummy) */
      verify: '/verify',
    },
    portabilidad: {
      /** POST /portabilidad/iniciar — Inicia el proceso y abre la fase comercial (US-001) */
      iniciar: '/iniciar',
    },
  },

  timeout: {
    default: 30000,
    pretups: 30000,
    maxRetries: 3,
  },
} as const;
